import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from '@angular/core';

import { Observable } from 'rxjs';

import { ArrowDirection } from '@apps/app.constants';

@Component({
    selector: 'aa-arrow-combo',
    templateUrl: './arrow-combo.component.html',
    styleUrls: [
        './arrow-combo.component.scss'
    ],
    standalone: false
})
export class ArrowComboComponent implements OnInit, OnDestroy
{
    @Input() fromParentComponentClick: Observable<any>;
    @Output() arrowClick: EventEmitter<ArrowDirection> = new EventEmitter<ArrowDirection>();
    public title: string;
    public caretDown: boolean;
    /**
     *
     */
    constructor (
    )
    {
    }

    ngOnInit (): void
    {
        this.caretDown = true;
        this.title = this.getTitle();
    }

    ngOnDestroy (): void
    {
        // throw new Error("Method not implemented.");
    }

    public onClickArrow = (): void =>
    {
        this.caretDown = !this.caretDown;
        this.title = this.getTitle();
        this.arrowClick.emit(
            this.caretDown ? ArrowDirection.CLOSED : ArrowDirection.OPEN
        );
        // if (this.open)
        // {
        //     clearTimeout(this.intervalId);
        //     this.intervalId = setTimeout(() => this.open = false, 5000);
        // }
    };

    private getTitle = (): string =>
        'BUTTON.' + (this.caretDown ? 'EXPAND' : 'COLLAPSE');
}
